import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("country-icon", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-copy-to-clipboard
                text-to-copy="I just got copied!"
                click-to-copy-message="Copy hidden text!"
                click-to-copy-message-successful="It worked!"
                hide-text-to-copy="true"
                click-to-copy-icon="watchlist"
                click-to-copy-icon-successful="order-status-package-checkmark"
            />`
        );
        const el = await page.find("ux-copy-to-clipboard");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-copy-to-clipboard
                text-to-copy="I just got copied!"
                click-to-copy-message="Copy hidden text!"
                click-to-copy-message-successful="It worked!"
                hide-text-to-copy="true"
                click-to-copy-icon="watchlist"
                click-to-copy-icon-successful="order-status-package-checkmark"
            />`);
    });
});
